import script from "./Step.vue?vue&type=script&setup=true&lang=js"
export * from "./Step.vue?vue&type=script&setup=true&lang=js"

import "./Step.vue?vue&type=style&index=0&id=1e04742c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e04742c"]])

export default __exports__